<template>
    <div class="cz2__paper-status">
        <!-- eslint-disable -->
        <transition name="cz2__fade">
            <div v-if="lowPaper" class="cz2__low-paper">
                <img
                    src="../assets/icons/alert.svg"
                    alt="Low Paper"
                />
            </div>
        </transition>

        <transition name="cz2__fade">
            <div v-if="outOfPaper" class="cz2__out-of-paper">
                <img
                    src="../assets/icons/alert.svg"
                    alt="Low Paper"
                />

                <div>
                    <div class="cz2__out-of-paper__header">
                        {{$t('OUT_OF_PAPER')}}
                    </div>

                    <div class="cz2__out-of-paper__text">
                        {{$t('OUT_OF_PAPER_ICON')}}
                    </div>
                </div>
            </div>
        </transition>

        <!-- eslint-enable -->
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__paper-status {
            position: absolute;

            left: 24px;
            top: 32px;

            z-index: 10000;
        }

        .cz2__low-paper {
            position: relative;

            img {
                width: 44px;
            }
        }

        .cz2__out-of-paper {
            width: 100%;
            height: 58px;

            padding: 0 24px;

            border: 5px solid #f7ab46;
            background: #fff;

            border-radius: 100px;

            display: flex;
            justify-content: flex-start;
            align-items: center;

            gap: 16px;

            img {
                width: 44px;
            }
        }

        .cz2__out-of-paper__header {
            font-size: 12px;
            text-transform: uppercase;
            font-family: var(--cz-font-700-family);
        }

        .cz2__out-of-paper__text {
            font-size: 12px;
            font-family: var(--cz-font-400-family);
        }
    }
</style>

<script>
    export default {
        computed: {
            lowPaper() {
                return this.$store.getters.lowPaper;
            },

            outOfPaper() {
                return this.$store.getters.outOfPaper;
            },
        },
    };
</script>
